import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
    SET_ARRANGE_MEETING,
    GET_APPLICATION_DOC_BYPARAMS,
    GET_MEETING_ARRANGEMENT_MEMBER_LIST,
    ADD_MEETING_ARRANGEMENT_FORM,
    EDIT_MEETING_ARRANGEMENT_FORM,
    GET_MEETING_ARRANGE_LIST,
    GET_MEETING_ARRANGEMENT_FORM_DETAIL,
} from 'store/key';
import { produce } from 'utility/general';
import { setGlobal, setGlobalLoading } from 'store/global/reducer';
import API from 'api/call';
import { safeSaga } from 'store';
import { ERROR } from 'utility/errorCode';

const initialState = {
    applicationDocData: null,
    meetingArrangementMemberList: null,
    meetingArrangeList: [],
    meetingArrangeTotal: 0,
};

function* getApplicationDocByParams(action) {
    const { params, callback } = action.payload;
    const { arrangeMeeting } = yield select();
    try {
        const result = yield call(API.arrangeMeeting.getApplicationDocByParams, { params });
        let data = result?.data?.result;
        data?.result.forEach((ele) => {
            ele.id = `${ele.documentId}${ele.documentType}`;
        });
        arrangeMeeting.applicationDocData = data;
        yield put({
            type: SET_ARRANGE_MEETING,
            payload: arrangeMeeting,
        });

        callback?.();
    } catch (error) {
        console.log('create reviewer failed:', error);
    }
}
function* getMeetingArrangementMemberList(action) {
    const { params, callback } = action.payload;
    const { arrangeMeeting } = yield select();
    try {
        const result = yield call(API.arrangeMeeting.getMeetingArrangementMemberList, { params });
        arrangeMeeting.meetingArrangementMemberList = result?.data?.result;
        yield put({
            type: SET_ARRANGE_MEETING,
            payload: arrangeMeeting,
        });

        callback?.();
    } catch (error) {
        console.log('create reviewer failed:', error);
    }
}
function* addMeetingArrangementForm(action) {
    const { data, callback } = action.payload;
    setGlobalLoading(true);
    try {
        const result = yield call(API.arrangeMeeting.addMeetingArrangementForm, { data });

        if (result.data.status === ERROR) {
            yield put(
                setGlobal({
                    isErrorShow: true,
                    errorMessage: decodeURIComponent(result.data?.errorMessage ?? 'Arrange meeting failed.'),
                    errorTitle: 'Reminder',
                }),
            );

            throw new Error(result.data?.errorMessage);
        }

        callback?.();
    } catch (error) {
        console.log('create reviewer failed:', error);
    }
    setGlobalLoading(false);
}

function* editMeetingArrangementForm(action) {
    const { data, callback } = action.payload;
    setGlobalLoading(true);
    try {
        const result = yield call(API.arrangeMeeting.editMeetingArrangementForm, { data });

        if (result.data.status === ERROR) {
            yield put(
                setGlobal({
                    isErrorShow: true,
                    errorMessage: decodeURIComponent(result.data?.errorMessage ?? 'Arrange meeting edit failed.'),
                    errorTitle: 'Reminder',
                }),
            );

            throw new Error(result.data?.errorMessage);
        }

        callback?.();
    } catch (error) {
        console.log('edit reviewer failed:', error);
    }
    setGlobalLoading(false);
}

function* getMeetingArrangeList(action) {
    const { params, callback } = action.payload;
    const { arrangeMeeting } = yield select();
    try {
        const result = yield call(API.arrangeMeeting.getMeetingArrangeList, params);
        const res = result.data.result;
        arrangeMeeting.meetingArrangeList = res.data;
        arrangeMeeting.meetingArrangeTotal = res.total;

        yield put({
            type: SET_ARRANGE_MEETING,
            payload: arrangeMeeting,
        });

        callback?.();
    } catch (error) {
        console.log('create reviewer failed:', error);
    }
}
function* getMeetingArrangementFormDetail(action) {
    const { params, callback } = action.payload;
    setGlobalLoading(true);
    try {
        const result = yield call(API.arrangeMeeting.getMeetingArrangementFormDetail, params);
        const res = result.data.result;
        callback?.(res);
    } catch (error) {
        console.log('create reviewer failed:', error);
    }
    setGlobalLoading(false);
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ARRANGE_MEETING:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};
export function* watchArrangeMeeting() {
    yield takeEvery(GET_APPLICATION_DOC_BYPARAMS, safeSaga(getApplicationDocByParams));
    yield takeEvery(GET_MEETING_ARRANGEMENT_MEMBER_LIST, safeSaga(getMeetingArrangementMemberList));
    yield takeEvery(ADD_MEETING_ARRANGEMENT_FORM, safeSaga(addMeetingArrangementForm));
    yield takeEvery(EDIT_MEETING_ARRANGEMENT_FORM, safeSaga(editMeetingArrangementForm));
    yield takeEvery(GET_MEETING_ARRANGE_LIST, safeSaga(getMeetingArrangeList));
    yield takeEvery(GET_MEETING_ARRANGEMENT_FORM_DETAIL, safeSaga(getMeetingArrangementFormDetail));
}

export default reducer;
